import { raceStatic } from '../operator/race';

export const race = raceStatic;



// WEBPACK FOOTER //
// ./node_modules/rxjs/src/observable/race.ts